"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodType = void 0;
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["APPLE_PAY"] = "apple-pay";
    PaymentMethodType["CREDIT_CARD"] = "credit-card";
    PaymentMethodType["SHOPIFY_PAYMENTS"] = "shopify-payments";
    PaymentMethodType["IDEAL"] = "ideal";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
